import cn from 'classnames/bind';
import * as React from 'react';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const Chip = (props) => {
    const { size = 'size-small', href = '#', target = '_self', children, onClick, disabled = false, classes = [], } = props;
    const chipClasses = cx('sbt-chip', 'weight-book', size, classes, {
        disabled,
    });
    if (disabled) {
        return (React.createElement("button", { type: "button", className: chipClasses, disabled: disabled }, children));
    }
    return (React.createElement("a", { role: "button", href: href, onClick: onClick, target: target, className: chipClasses }, children));
};

export { Chip };
//# sourceMappingURL=index.js.map
